module.exports = "./assets/assets/公开开招标(货物).06411cb5.docx";